export default function ChatCss() {
    return (
        <style>
            {`
                .profile {
                    display: flex;
                    padding-left: 0;
                    padding-right: 0;
                }
                @media(min-width: 1101px) {
                    /* Чат управляет своей прокруткой сам и должен занимать всю высоту. */
                    .profile {
                        height: 100dvh;
                        min-height: 100dvh;
                        overflow: hidden;
                    }
                }
                main {
                    margin-bottom: 0 !important;
                    max-width: 100%;
                }
                .chat__motion-div {
                    padding-left: 24px;
                    padding-right: 24px;
                }
                @media(max-width: 1100px) {
                    .profile {
                        flex-direction: column;
                    }

                    .MuiContainer-root {
                        padding-left: 0px;
                        padding-right: 0px;
                    }

                    .profile__header {
                        padding-left: 16px;
                        padding-right: 16px;
                    }

                    .chat__motion-div {
                        height: calc(100dvh - 56.35px) !important;
                        padding-left: 0;
                        padding-right: 0;
                    }
                }
                `}
        </style>
    )
}
